import { GendersList } from '@gtpl/shared-models/gtpl';
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ProfileEntity } from '../profile/profile.entity';

@Entity('wards')
export class WardsEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:false,
    length:500,
    name:"ward_no"
  })
  wardNo:string;
  
  @Column("boolean",{
    nullable:false,
    default:true,               
    name:"status" 
  })
  status:boolean;

  @OneToMany(() => ProfileEntity, (profile:ProfileEntity) => profile.ward)
  profile: ProfileEntity;  

}
